var map = {
	"./data": [
		"5055",
		"chunk-5fac551a"
	],
	"./data.vue": [
		"5055",
		"chunk-5fac551a"
	],
	"./settings": [
		"d697",
		"chunk-6bfc3f8f"
	],
	"./settings.vue": [
		"d697",
		"chunk-6bfc3f8f"
	],
	"./view": [
		"3a1a",
		"chunk-4ef9cacb"
	],
	"./view.vue": [
		"3a1a",
		"chunk-4ef9cacb"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "81fb";
module.exports = webpackAsyncContext;